import apiUrl from '../../../utils/settings';

export const dashboardUrl =
  apiUrl + '/user-performance-dashboard/user-sales-performance';

export const networkInfoListUrl =
  apiUrl + '/user-performance-dashboard/network-info-list';

export const networkInfoDetailUrl =
  apiUrl + '/user-performance-dashboard/network-details';

export const poPerformanceDetailsUrl =
  apiUrl + '/user-performance-dashboard/po-performance-details';
